import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/'

import EmptyRouterView from './layouts/EmptyRouterView.vue'

import Decisions from './views/Decisions.vue'
import Admin from './views/Admin.vue'
import Market from './components/admin/Market.vue'
import Teams from './components/admin/Teams.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about as',
      component: () => import('@/views/About.vue'),
    },
    {
      path: '/media',
      name: 'media',
      component: () => import('@/views/Media.vue'),
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('@/views/Partners.vue'),
    },
    {
      path: '/customers',
      name: 'customers',
      component: () => import('@/views/Customers.vue'),
    },
    {
      path: '/contacts',
      name: 'about as',
      component: () => import('@/views/Contacts.vue'),
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {authRequired: true},
      component: EmptyRouterView,
      children: [
        {
          name: 'Instructor page',
          path: '',
          component: Admin
        },
        {// market information
          name: 'admin.market',
          path: 'market',
          meta: {authRequired: true},
          component: Market,
          children: [
                { 
                  name: 'admin.market.segments',
                  path: 'segments'
                },
                { 
                  name: 'admin.market.media',
                  path: 'media'
                },
                { 
                  name: 'admin.market.design',
                  path: 'design'
                },
                { 
                  name: 'admin.market.materials',
                  path: 'materials'
                },
                { 
                  name: 'admin.market.chains',
                  path: 'chains',
                  component: () => import('@/components/admin/market/IndependentChains.vue')
                },
          ] 
        },
        {//team info
          name: 'admin.teams',
          path: 'teams',
          meta: {authRequired: true},
          component: Teams,
          children: [
                { 
                  name: 'admin.teams.information',
                  path: 'information'
                },
                { 
                  name: 'admin.teams.products',
                  path: 'products'
                },
                { 
                  name: 'admin.teams.sales',
                  path: 'sales'
                },
                { 
                  name: 'admin.teams.retail',
                  path: 'retail'
                },
                { 
                  name: 'admin.teams.promotion',
                  path: 'promotion'
                },
                { 
                  name: 'admin.teams.finance',
                  path: 'finance'
                }
          ] 
        },
        {//calculating info
          name: 'admin.summary',
          path: 'summary',
          meta: {authRequired: true},
          component: () => import(/* webpackChunkName: "summary" */ './components/admin/Summary.vue'),
          children: [
            { 
              name: 'admin.summary.chains & franchises',
              path: 'franchise'
            },
            { 
              name: 'admin.summary.actual peak size',
              path: 'peakSize'
            },
            { 
              name: 'admin.summary.awareness',
              path: 'awareness'
            },
            { 
              name: 'admin.summary.advanced features',
              path: 'advancedFeatures'
            },
            { 
              name: 'admin.summary.brand loyalty',
              path: 'brandLoyalty'
            },
            { 
              name: 'admin.summary.max size',
              path: 'segmentsMaxSize'
            },
            { 
              name: 'admin.summary.segments sales',
              path: 'segmentsSales'
            },
            { 
              name: 'admin.summary.sales',
              path: 'sales'
            },
            { 
              name: 'admin.summary.channels sales',
              path: 'channelsSales'
            },
            {
              name: 'admin.summary.financialSummary',
              path: 'financialSummary', 
            }
          ] 
        }, 
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/registr',
      name: 'registr',
      component: () => import(/* webpackChunkName: "registr" */ './views/Registration.vue')
    },
    {
      path: '/customer',
      name: 'customer',
      meta: {authRequired: true},
      component: EmptyRouterView, 
      children: [
        {//customer
          name: 'customer page',
          path: '',
          meta: {authRequired: true},
          component: () => import(/* webpackChunkName: "customer" */ './views/Customer.vue')
        },
        {//company desicions
          name: 'customer.decisions',
          path: 'decisions',
          meta: {authRequired: true},
          component: Decisions,
          children: [{path: 'pm', component: Decisions}, {path: 'sales', component: Decisions},
            {path: 'retail', component: Decisions}, {path: 'promotion', component: Decisions}, 
            {path: 'consultancy', component: Decisions}, {path: 'finance', component: Decisions}
          ]
        },
        {//market reports for companies
          name: 'customer.market',
          path: 'market',
          meta: {authRequired: true},
          component: () => import(/* webpackChunkName: "customer" */ './views/Market.vue'),
          children: [{path: 'marketSize', name: 'customer.market.marketSize'}, 
            {path: 'designReport', name: 'customer.market.designReport'},
            {path: 'm&mReport', name: 'customer.market.M&MReport'},
            {path: 'afReport', name: 'customer.market.AFReport'},
            {path: 'consumersHabits', name: 'customer.market.consumersHabits'},
            {path: 'mediaPreferences', name: 'customer.market.mediaPreferences'},
            {path: 'products', name: 'customer.market.products'},
            {path: 'retailReports', name: 'customer.market.retailReports'}
          ]
        },
        {//company reports
          name: 'customer.reports',
          path: 'reports',
          meta: {authRequired: true},
          component: () => import(/* webpackChunkName: "customer" */ './views/Reports.vue'),
          children: [{path: 'trademarks', name: 'customer.reports.trademarks'}, 
            {path: 'sales', name: 'customer.reports.sales'},
            {path: 'retailChannels', name: 'customer.reports.retailChannels'},
            {path: 'segmentResults', name: 'customer.reports.segmentResults'}, 
            {path: 'financialSummary', name: 'customer.reports.financialSummary'}]
        },
        {//instructions
          name: 'customer.instructions',
          path: 'instructions',
          meta: {authRequired: true},
          children: []
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  
  store.dispatch('initAuth')
    .then(claims => {
      if (to.matched.some(route => route.meta.authRequired)) {
        if (claims) {
          if (claims.admin) {
            if (/^\/admin\/*/i.test(to.path)) next();
            else next('/admin')
          }
          else if(claims.customer) {
            if (/^\/customer\/*/i.test(to.path)) next()
            else next({path: '/customer'});
          } 
        }
        else {
          next({ path: '/login',
            query: { redirect: to.fullPath }
          });
        }/**/
      }
      else {
        next();
      }  
  })
});

export default router

